"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.searchGroupSort = exports.sortFunc = exports.sortPriority = exports.validateSearchQuery = exports.MIN_SEARCH_LENGTH = exports.SearchPageSize = void 0;
const Types_1 = require("@/Types");
exports.SearchPageSize = 10;
exports.MIN_SEARCH_LENGTH = 1;
const SEARCH_REGEX = /^[^`~{}]+$/;
const validateSearchQuery = (query) => {
    const trimmedQuery = query.trim();
    if (trimmedQuery.length < exports.MIN_SEARCH_LENGTH)
        return false;
    return SEARCH_REGEX.test(trimmedQuery) ? trimmedQuery : false;
};
exports.validateSearchQuery = validateSearchQuery;
exports.sortPriority = [
    Types_1.SearchTypeEnum.PRODUCTS,
    Types_1.SearchTypeEnum.CROSS_REFERENCE,
    Types_1.SearchTypeEnum.SAF_HOLLAND_PRODUCTS,
    Types_1.SearchTypeEnum.PRESS_RELEASES,
    Types_1.SearchTypeEnum.REPORTS,
    Types_1.SearchTypeEnum.NEWS,
    Types_1.SearchTypeEnum.PAGES,
    Types_1.SearchTypeEnum.TAGS
];
const sortFunc = (a, b) => exports.sortPriority.indexOf(a[0]) - exports.sortPriority.indexOf(b[0]);
exports.sortFunc = sortFunc;
const searchGroupSort = (obj) => {
    const resultArr = Object.entries(obj);
    const filteredArr = resultArr.filter(([key, value]) => {
        var _a;
        return key === Types_1.SearchTypeEnum.CROSS_REFERENCE || key === Types_1.SearchTypeEnum.SAF_HOLLAND_PRODUCTS
            ? ((_a = value.hits) === null || _a === void 0 ? void 0 : _a.length) > 0
            : (value === null || value === void 0 ? void 0 : value.totalMatching) > 0;
    });
    return filteredArr.sort(exports.sortFunc);
};
exports.searchGroupSort = searchGroupSort;
